import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Grid, IconButton, Menu, MenuItem, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import PeopleIcon from "@mui/icons-material/People";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ReyLeaf from "../../../common/assests/reyleafLogo.svg";
import { allUserCommentsDataApi, deleteForumApi, getAllModerationForumPost, postDeleteApi, updateFourmApi } from "../../../api";
import { useSelector } from "react-redux";
import UserAvatar from "../../../common/avatar/UserAvatar";
import CommentModal from "../../../common/customModal/CommentModal";
import { toast } from "react-toastify";
import { useConfirm } from "../../../common/confirmDialog/useConfirm";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import ForumModal from "../ForumModal";
import configuration from "../../../config/Config";
import { formatCount } from "../../../utils/formatCount";

const ModrationDetail = () => {
  const token = useSelector((state) => state?.user?.user?.token);
  const confirm = useConfirm();
  const navigate = useNavigate();
  const location = useLocation();
  const [event, setEvent] = useState(location.state?.event || {});
  const [postData, setPostData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [opens, setOpens] = useState(false);
  const [change, setChange] = useState(false);
  const [postID, setPostId] = useState(null);
  const [commentModalOpen, setCommentModalOpen] = useState(false);
  const [editingData, setEditingData] = useState(null);
  const [commentData, setCommentData] = useState([]);
  const [commentCurrentPage, setCommentCurrentPage] = useState(1);
  const [commentTotalPages, setCommentTotalPages] = useState(0);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClickForumOpen = (data) => {
    setEditingData(data || null);
    setOpens(true);
  };
  const handleForumClose = () => setOpens(false);

  const handleModalOepn = (comment) => {
    setPostId(comment?._id);
    handleCommentDetails(comment?._id);
    setCommentModalOpen(true);
  };
  const handleModalClose = () => setCommentModalOpen(false);

  const handleClick = (e, id) => {
    setPostId(id);
    setAnchorEl(e.currentTarget);
  };
  const handleClose = () => setAnchorEl(null);

  const handlePost = async () => {
    try {
      setLoading(true);
      const response = await getAllModerationForumPost({ token, id: event?._id });
      setPostData(response?.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("errror", error);
    }
  };

  useEffect(() => {
    handlePost();
  }, [change]);

  const handleSave = async (forumData, id) => {
    try {
      if (!forumData.title || !forumData.description) {
        toast.warning("Title and description required");
        return;
      }
      const response = await updateFourmApi({ token, forumData, id });
      setEvent((prev) => ({
        ...prev,
        title: response?.data?.title,
        description: response?.data?.description,
      }));
      toast.success(response?.message);
      handleForumClose();
    } catch (error) {
      toast.error(error?.message);
      console.error("Error saving forum", error);
    }
  };

  const handleDeleteForum = async (id) => {
    const confirmed = await confirm({ title: "Delete Forum", description: "Are you sure you want to delete this forum?", confirmText: "Delete", destructive: true });
    if (!confirmed) return;
    try {
      const response = await deleteForumApi({ token, id });
      toast.success(response?.message);
      navigate(-1);
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleDeletePost = async (id) => {
    const confirmed = await confirm({ title: "Delete Post", description: "Are you sure you want to delete this post?", confirmText: "Delete", destructive: true });
    if (!confirmed) return;
    try {
      const response = await postDeleteApi({ token, id });
      toast.success(response?.message);
      setChange(!change);
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleCommentDetails = async (id) => {
    try {
      const response = await allUserCommentsDataApi({ token, id, commentCurrentPage });
      setCommentData((prev) => [...prev, ...(response?.comment || [])]);
      setCommentTotalPages(response?.totalPages || 1);
      setCommentCurrentPage(response?.currentPage || 1);
    } catch (error) {
      toast.error(error?.error || error?.message);
    }
  };

  useEffect(() => {
    if (postID) handleCommentDetails(postID);
  }, [commentCurrentPage]);

  const loadMoreTickets = () => {
    if (commentCurrentPage < commentTotalPages) setCommentCurrentPage((p) => p + 1);
  };

  const hasMoreTickets = commentCurrentPage < commentTotalPages;

  return (
    <div style={{ maxWidth: "1420px" }}>
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", p: 6 }}>
          <CircularProgress sx={{ color: "#065F46" }} />
        </Box>
      ) : (
        <>
          {/* Back nav */}
          <Box
            onClick={() => navigate(-1)}
            sx={{ display: "flex", alignItems: "center", gap: 1, cursor: "pointer", width: "fit-content", mb: 2 }}
          >
            <ArrowBackIcon sx={{ color: "#065F46", fontSize: 22 }} />
            <Typography sx={{ color: "#065F46", fontWeight: "500", fontSize: "18px", fontFamily: "Heebo" }}>
              Back
            </Typography>
          </Box>

          {/* Forum detail card */}
          <Box
            sx={{
              borderRadius: "24px",
              backgroundColor: "#FFF",
              boxShadow: "3px 2px 20px 0px rgba(0, 0, 0, 0.04)",
              overflow: "hidden",
              mb: 3,
            }}
          >
            {/* Banner image */}
            <Box
              component="img"
              src={event?.picture ? `${configuration.cdnFront}/${event?.picture}` : ReyLeaf}
              alt="forum banner"
              sx={{
                width: "100%",
                height: { xs: 160, sm: 220, md: 280 },
                objectFit: "cover",
                display: "block",
              }}
            />

            {/* Forum info */}
            <Box sx={{ p: { xs: "16px", sm: "24px" } }}>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 1 }}>
                <Typography
                  sx={{ fontFamily: "Heebo", fontWeight: "700", fontSize: { xs: "18px", sm: "22px" }, color: "#362B24", flex: 1, mr: 1 }}
                >
                  {event?.title || "N/A"}
                </Typography>
                <Box sx={{ display: "flex", gap: 0.5, flexShrink: 0 }}>
                  <IconButton onClick={() => handleClickForumOpen(event)} size="small" sx={{ color: "#065F46" }}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                  <IconButton onClick={() => handleDeleteForum(event?._id)} size="small" sx={{ color: "#EA001B" }}>
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Box>
              </Box>

              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 1.5 }}>
                <PeopleIcon sx={{ fontSize: 16, color: "#065F46" }} />
                <Typography sx={{ fontFamily: "Heebo", color: "#065F46", fontWeight: "500", fontSize: "13px" }}>
                  {formatCount(event?.members?.length)} Members
                </Typography>
              </Box>

              <Typography
                sx={{ fontFamily: "Heebo", color: "#362B24", opacity: 0.7, fontSize: "14px", lineHeight: "22px" }}
              >
                {event?.description || "N/A"}
              </Typography>
            </Box>
          </Box>

          {/* Posts section */}
          <Typography
            sx={{ fontFamily: "Heebo", fontWeight: "600", fontSize: { xs: "18px", sm: "20px" }, color: "#362B24", mb: 2, pl: "4px" }}
          >
            All User Posts
          </Typography>

          {postData?.memberFeeds?.length > 0 ? (
            <Grid container spacing={3}>
              {postData.memberFeeds.map((item) => (
                <Grid item xs={12} sm={6} lg={4} key={item?._id}>
                  <Box
                    sx={{
                      borderRadius: "20px",
                      backgroundColor: "#FFF",
                      boxShadow: "1px 2px 30px 0px rgba(0, 0, 0, 0.06)",
                      display: "flex",
                      flexDirection: "column",
                      overflow: "hidden",
                    }}
                  >
                    {/* Post header */}
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", p: "14px 14px 0" }}>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <UserAvatar
                          src={item?.userDetails?.picture ? `${configuration.cdnFront}/${item.userDetails.picture}` : undefined}
                          name={item?.userDetails?.fullname}
                          size={40}
                          sx={{ flexShrink: 0 }}
                        />
                        <Box>
                          <Typography sx={{ fontWeight: "700", fontSize: "13px", color: "#362B24", fontFamily: "Heebo" }}>
                            {item?.userDetails?.fullname || "Unknown"}
                          </Typography>
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 0.3 }}>
                            <AccessTimeIcon sx={{ fontSize: 12, color: "#065F46" }} />
                            <Typography sx={{ fontSize: "11px", color: "#065F46", fontFamily: "Heebo" }}>
                              {item?.updated_at
                                ? new Date(item.updated_at).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })
                                : "N/A"}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>

                      <IconButton size="small" onClick={(e) => handleClick(e, item?._id)}>
                        <MoreVertIcon sx={{ color: "#8B8B8B", fontSize: 20 }} />
                      </IconButton>
                    </Box>

                    {/* Post images */}
                    {item?.photos?.length > 0 && (
                      <Box sx={{ mt: 1.5, overflow: "hidden" }}>
                        {item.photos.length === 1 ? (
                          <Box
                            component="img"
                            src={item.photos[0]?.url ? `${configuration.cdnFront}/${item.photos[0].url}` : ReyLeaf}
                            alt="post"
                            sx={{ width: "100%", height: 220, objectFit: "cover", display: "block" }}
                          />
                        ) : (
                          <Swiper
                            spaceBetween={0}
                            slidesPerView={1}
                            loop={true}
                          >
                            {item.photos.map((photo, indx) => (
                              <SwiperSlide key={indx}>
                                <Box
                                  component="img"
                                  src={photo?.url ? `${configuration.cdnFront}/${photo.url}` : ReyLeaf}
                                  alt={`slide-${indx}`}
                                  sx={{ width: "100%", height: 220, objectFit: "cover", display: "block" }}
                                />
                              </SwiperSlide>
                            ))}
                          </Swiper>
                        )}
                      </Box>
                    )}

                    {/* Description */}
                    {item?.description && (
                      <Typography
                        sx={{ fontSize: "13px", color: "#362B24", opacity: 0.7, fontFamily: "Heebo", lineHeight: "20px", p: "12px 14px 0" }}
                      >
                        {item.description}
                      </Typography>
                    )}

                    {/* Footer: likes / comments */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2, p: "12px 14px 14px", mt: "auto" }}>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                        <FavoriteIcon sx={{ color: "#E53935", fontSize: 18 }} />
                        <Typography sx={{ fontSize: "13px", fontFamily: "Heebo", color: "#362B24" }}>
                          {formatCount(item?.likeCount)}
                        </Typography>
                      </Box>
                      <Box
                        onClick={() => handleModalOepn(item)}
                        sx={{ display: "flex", alignItems: "center", gap: 0.5, cursor: "pointer" }}
                      >
                        <ChatBubbleOutlineIcon sx={{ color: "#8B8B8B", fontSize: 18 }} />
                        <Typography sx={{ fontSize: "13px", fontFamily: "Heebo", color: "#362B24" }}>
                          {formatCount(item?.comments?.length)}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>

                  <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{ "aria-labelledby": "basic-button" }}
                    sx={{
                      "& .MuiPaper-root": {
                        borderRadius: "12px 0px 12px 12px",
                        boxShadow: "1px 2px 16px 0px rgba(0, 0, 0, 0.10)",
                        minWidth: "100px",
                      },
                    }}
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    transformOrigin={{ vertical: "top", horizontal: "right" }}
                  >
                    <MenuItem
                      onClick={() => { handleDeletePost(postID); handleClose(); }}
                      sx={{ fontFamily: "Heebo", color: "#EA1D26", fontSize: "13px" }}
                    >
                      Delete
                    </MenuItem>
                  </Menu>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Typography sx={{ textAlign: "center", color: "#8B8B8B", fontFamily: "Heebo", py: 6 }}>
              No posts found
            </Typography>
          )}
        </>
      )}

      <CommentModal
        open={commentModalOpen}
        onClose={handleModalClose}
        data={commentData}
        hasMore={hasMoreTickets}
        loadMore={loadMoreTickets}
      />
      <ForumModal
        open={opens}
        handleClose={handleForumClose}
        handleSave={handleSave}
        editingData={editingData}
      />
    </div>
  );
};

export default ModrationDetail;
